import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, FormField, initFormHandler } from '#app/Handler/FormHandler';
import { Payload } from '#app/View/Sale/OrderClient/SaleOrderClient/components/DisputeModal';
import { ByProduct } from '#app/typings/order';

type Props = {
  onClose: () => void;
  products: ByProduct[];
  loading: boolean;
  onSubmit: (payload: Payload) => void;
};

const DisputeOrder: React.FC<Props> = ({ onClose, products, loading, onSubmit }) => {
  const [form, setForm] = useState<Form>({
    reason: {
      name: 'reason',
      label: 'Raison',
      textHelper: 'Saisissez une raison.',
      type: 'text',
    },
    ...products.reduce((acc: Record<string, FormField>, product) => {
      acc[product.id] = {
        name: product.id.toString(),
        label: 'Quantité',
        textHelper: `Saisissez la quantité de produit en litige (maximum : ${product.amount - product.amountShipped - product.amountLitige})`,
        type: 'integer',
        options: {
          validation: ['required'],
          max: product.amount - product.amountShipped - product.amountLitige,
        },
      };
      return acc;
    }, {}),
  });

  const handlerForm = initFormHandler(form, setForm);

  useEffect(() => {
    handlerForm.start();
  }, []);

  const handleSubmit = (): void => {
    if (handlerForm.checkError() < 1) {
      handlerForm.setFormLoading(true);

      const data = handlerForm.getData();

      onSubmit({
        reason: data.reason,
        products: Object.entries(data)
          .filter(([key]) => !isNaN(parseInt(key)))
          .map(([key, value]) => ({
            quantity: value as number,
            byProduct: parseInt(key),
          })),
      });
    }
  };

  return (
    <>
      <Grid size={12}>
        <TextFieldComponent id="reason" handler={handlerForm} multiline />
      </Grid>

      {products.map((product) => (
        <React.Fragment key={product.id}>
          <Grid size={6}>
            <p>{product.name}</p>
          </Grid>
          <Grid size={6}>
            <TextFieldComponent id={product.id.toString()} handler={handlerForm} />
          </Grid>
        </React.Fragment>
      ))}

      <Grid size={12} container spacing={2} justifyContent="end">
        <ButtonComponent color="#5E6E82" label="Annuler" onClick={onClose} loading={loading} />
        <ButtonComponent label="Enregistrer" onClick={handleSubmit} loading={loading} />
      </Grid>
    </>
  );
};

export default DisputeOrder;
